import { ITextProps } from 'native-base';

import { HeaderAccessibilityLevel, HeaderVariant } from 'styles/constants/fonts';

import { addWithConfig } from '../../utils';
import { Text } from '../text';

export type HeaderProps = {
  accessibilityLevel?: HeaderAccessibilityLevel;
  variant?: HeaderVariant;
  focusable?: boolean;
} & ITextProps;

export const Header = (props: HeaderProps) => <Text variant="headerOne" {...props} />;

export default addWithConfig(Header);
